import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

/* NgRx */
// import { StoreModule } from '@ngrx/store';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// import { EffectsModule } from '@ngrx/effects';


// Servicios para componentes auxiliares
// import { SortableColumnService } from './sortableColumn.service';
import { SharingModuleDirective } from './sharingModule.directive';
import { SharingModuleComponent } from './sharingModule.component';

// Filtros Pipe genéricos customizados.
import { FilterPipe, FilterParamPipe, WriteDimensionPipe, levelAnidPipe, localLevelAnidPipe } from '../_helpers/pipe';

@NgModule({
  declarations: [
    SharingModuleDirective,
    SharingModuleComponent,
    FilterPipe,
    FilterParamPipe,
    WriteDimensionPipe,
    levelAnidPipe,
    localLevelAnidPipe
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule
  ],
  exports: [
    SharingModuleDirective,
    SharingModuleComponent,
    FilterPipe,
    FilterParamPipe,
    WriteDimensionPipe,
    levelAnidPipe,
    localLevelAnidPipe,
    CommonModule,
    FormsModule,
    ReactiveFormsModule
  ]
})
export class SharingModule {
  constructor(
  ) {}

}